import { CompetitionsMenuSchema } from '@/views/sports/components/CompetitionsMenu/styles/CompetitionsMenu.styles';

export const competitionsMenuStyles: CompetitionsMenuSchema = {
  accordion: {
    color: 'white',
    minW: '190px',
    mr: '4',
    height: 'fit-content',
    boxShadow:
      '0px 3px 5px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    borderRadius: 'md',
    overflow: 'hidden',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
  },
  accordionButton: {
    pl: '3',
    pr: '2',
    bgGradient: 'linear(to-b, brand.600, brand.700)',
    borderBottomWidth: '1px',
    borderBottomColor: 'delta.300',
    _hover: {
      bgGradient: 'linear(180deg, brand.600 0%, brand.700 100%)',
    },
  },
  accordionHeadingText: {
    flex: '1',
    fontSize: 'sm',
    textAlign: 'left',
    fontWeight: 'bold',
    color: 'white',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  accordionIcon: {
    color: 'white',
  },
  accordionPanel: {
    p: '0',
    bg: 'brand.800',
    color: 'white',
    _last: {
      border: 'none',
    },
  },
};
